import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Fire-and-forget UI events shared between table chrome and list views.
 * Pagination is event-style (no retained state); keep as RxJS, not signals.
 */
@Injectable({ providedIn: 'root' })
export class TableUiEventsService {
  private readonly paginationChange = new Subject<void>();

  /** Emitted when the user changes page index or page size. */
  readonly paginationChange$ = this.paginationChange.asObservable();

  notifyPaginationChange(): void {
    this.paginationChange.next();
  }
}
